import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './excerpt_summary.module.scss';
import { isTouchDevice } from '../../../utils/domUtils';
import {
  WithRestrictedModalProps,
  withRestrictedModal,
} from '../../modal/components/modal-restricted/withRestrictedModal';
import { UserContextType } from '../../../user/user.types';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import { Hyperlink } from '../../Hyperlink';
import { withUser } from '../../../user/UserContext';

type Props = {
  source: string;
  hit: { url: string; visited: boolean; summary: string };
  additionalQueryParams: { [s: string]: string } | null;
  onHitClicked: Function;
  target: string;
} & WithRestrictedModalProps &
  UserContextType;

export class RawHitSummary extends React.Component<Props> {
  static defaultProps = {
    additionalQueryParams: null,
    target: '',
  };

  isTouchDevice = isTouchDevice();

  getHitUrl = () => {
    const { hit, source, additionalQueryParams } = this.props;
    const sourceParameters = { source };
    return buildUrlWithParameters(
      hit.url,
      additionalQueryParams
        ? { ...sourceParameters, ...additionalQueryParams }
        : sourceParameters,
    );
  };

  clickResult = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const {
      accessPremium,
      hit,
      source,
      openRestrictedModal,
      onHitClicked,
    } = this.props;

    if (accessPremium) {
      hit.visited = true;
      if (onHitClicked) {
        onHitClicked(event);
      }
    } else {
      openRestrictedModal(source);
    }
  };

  handleTouchClick = () => {
    const { accessPremium, source, openRestrictedModal } = this.props;
    if (this.isTouchDevice && accessPremium) {
      window.location.href = this.getHitUrl();
    } else if (this.isTouchDevice) {
      openRestrictedModal(source);
    }
  };

  render() {
    const { hit, accessPremium, target } = this.props;
    return (
      <div className={styles.container}>
        {hit.summary && (
          <p
            onClick={this.handleTouchClick}
            className={styles.content}
            dangerouslySetInnerHTML={{ __html: hit.summary }}
          />
        )}
        <Hyperlink
          {...(accessPremium ? { href: this.getHitUrl(), target } : {})}
          onClick={this.clickResult}
          className={classNames(styles.more, hit.visited && styles.visited)}
        >
          {'\u00A0'}
          <FormattedMessage id="excerpt/ExcerptSummary.tsx/1" />
        </Hyperlink>
      </div>
    );
  }
}

export const ExcerptSummary = withUser(withRestrictedModal(RawHitSummary));
